import { render, staticRenderFns } from "./ViewEvaluation.vue?vue&type=template&id=4f222b0f&"
import script from "./ViewEvaluation.vue?vue&type=script&lang=js&"
export * from "./ViewEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./ViewEvaluation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports